module.exports = __webpack_public_path__ + "media/images/city/009-blue-mosque-7bf4010a1815cd08485b0d632ba8003d.svg";